import { apolloClient } from '@/services/graphql';
import gql from 'graphql-tag';

export function getUser(uid: string) {
  return apolloClient
    .query({
      query: gql`
        query user($uid: ID!) {
          user: getUser(id: $uid) {
            name
            email
          }
        }
      `,
      variables: {
        uid
      }
    })
    .then(x => x.data.user);
}

export function queryUsers(query: string) {
  return apolloClient
    .query({
      query: gql`
        query($query: String) {
          users(query: $query) {
            _id
            email
            name
          }
        }
      `,
      variables: {
        query
      }
    })
    .then(x => x.data.users);
}
